import classnames from 'classnames'

import { AUTH_FORM_VARIANT } from '@/constants/layout'

import useBackNavigation from '@/hooks/useBackNavigation'
import useLayoutBreakpoints from '@/hooks/useLayoutBreakpoints'

import Header from '@/components/Header'
import Logo from '@/components/Logo'
import PageContainer from '@/components/PageContainer'

import styles from './AuthFormShell.module.scss'

const BACK_ICON = { name: 'leftArrow', fillColor: '#171717' }

const isFluidVariant = variant => variant === AUTH_FORM_VARIANT.FLUID

export default function AuthFormShell({
  children,
  variant = AUTH_FORM_VARIANT.CARD,
  headerVariant = null,
  hideHeaderOnDesktop = false,
  shellClassName,
  contentClassName,
  cardClassName
}) {
  const { goBack } = useBackNavigation()
  const { isCompact } = useLayoutBreakpoints()
  const isFluid = isFluidVariant(variant)
  const headerInShell = isCompact
  /* Card pages: header bottom border separates logo bar from form (cashloan login pattern). */
  const headerBorderless = isCompact && isFluid
  const showHeader = ['logo', 'back'].includes(headerVariant)

  const header = showHeader ? (
    <Header
      borderless={headerBorderless}
      hideOnDesktop={hideHeaderOnDesktop}
      icon={headerVariant === 'back' ? BACK_ICON : undefined}
      inShell={headerInShell}
      leftComponent={headerVariant === 'logo' ? Logo : undefined}
      onLeftIconClick={headerVariant === 'back' ? goBack : undefined}
    />
  ) : null

  if (isFluid) {
    return (
      <div className={classnames(styles.shell, styles.shellFluid, shellClassName)}>
        {header}
        <div className={classnames(styles.body, styles.bodyFluid, 'ew-mt-md-24', contentClassName)}>
          {children}
        </div>
      </div>
    )
  }

  return (
    <div className={classnames(styles.shell, styles.shellCard, shellClassName)}>
      {header}
      <div className={classnames(styles.body, styles.bodyCard, isCompact && styles.bodyCompact)}>
        <div className={classnames(styles.card, isCompact && styles.cardCompact, cardClassName)}>
          <PageContainer className={classnames('ew-d-flex ew-flex-column', contentClassName)}>
            {children}
          </PageContainer>
        </div>
      </div>
    </div>
  )
}
